import { query_staff_operation_list } from '@/api/mjstat-model';
import { TableColumn } from '@/typing';
import { SearchConfig, Record } from '@/components/page-model/typing';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY, STORAGE_CURRENT_SHOP_KEY } from '@/store/mutation-type';
import {
  slotList,
  btn_list,
  head_btn_list,
  event_obj,
  config,
} from '@/components/page-model/mjstat/mjstat-customer_operation_daily_report-config';

import { reactive } from 'vue';
import moment from 'moment';
const None = null;
const True = true;
const False = false;

const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
const current_shop = ls.get(STORAGE_CURRENT_SHOP_KEY);

const search_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'inline',
  },
  fields: [
    {
      type: 'rangepicker',
      name: 'date_interval',
      label: '运营日期',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      showTime: false,
      valueFormat: 'YYYY-MM-DD',
      placeholder: '请选择运营日期',
    },
  ],
  rules: {
    date_interval: [
      { required: true, message: '请输入运营日期', type: 'array' },
      {
        validator: (rule: any, value: any, callback: any) => {
          return new Promise((resolve: any, reject: any) => {
            if (value instanceof Array && value.length == 2) {
              if (value[0].substring(8) != '01') {
                callback();
                reject('开始日期必须选择当月1号');
              } else if (value[0].substring(5, 7) != value[1].substring(5, 7)) {
                callback();
                reject('日期不允许跨月');
              } else {
                callback();
                resolve();
              }
            }
          });
        },
        trigger: 'change',
      },
    ],
  },
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
    date_interval: [moment().format('YYYY-MM-01'), moment().format('YYYY-MM-01')],
    shop_id: null,
    pageSize: 5000,
  }),
};
const search_options = {};

const edit_model_config = {};
const edit_model_config_options = {};

const update_model_config = {};
const update_model_config_options = {};

const titleList = {
  title: '客户运营日报表',
  addModalTitle: '新建客户运营日报表',
  updateTitle: '编辑客户运营日报表',
  is_create: false, // 是否有【新建】按钮
  is_update: false, // 是否有【修改】按钮
  is_remove: false, // 是否有【删除】按钮
  is_recover: false, // 是否有【恢复】按钮
};

const api_fields: Record = {
  update: {
    id: 'id',
  },
  delete: {
    id: 'id',
  },
  recover: {
    id: 'id',
  },
  updateData: {
    org_id: 'org_id',
    id: 'id',
  },
};

const baseColumns: TableColumn[] = [
  {
    title: '序号',
    dataIndex: 'index',
    width: 50,
    fixed: 'left',
  },
  {
    title: '员工编号',
    dataIndex: 'staff_code',
    width: 120,
  },
  {
    title: '姓名',
    width: 120,
    dataIndex: 'staff_name',
    checked: true,
  },
  {
    title: '职位',
    width: 120,
    dataIndex: 'staff_title',
    checked: true,
  },
  {
    title: '营业目标额',
    width: 120,
    dataIndex: 'yye_target_amount',
    checked: true,
  },
  {
    title: '营业完成额',
    width: 120,
    dataIndex: 'yye_amount',
    checked: true,
  },
  {
    title: '营业额完成比',
    width: 120,
    dataIndex: 'yye_amount_percent',
    checked: true,
  },
  {
    title: '客流目标数',
    width: 120,
    dataIndex: 'kl_target_count',
    checked: true,
  },
  {
    title: '客流完成数',
    width: 120,
    dataIndex: 'kl_count',
    checked: true,
  },
  {
    title: '客流完成比',
    width: 120,
    dataIndex: 'kl_count_percent',
    checked: true,
  },
  {
    title: '人头目标数',
    width: 120,
    dataIndex: 'rt_target_count',
    checked: true,
  },
  {
    title: '人头完成数',
    width: 120,
    dataIndex: 'rt_count',
    checked: true,
  },
  {
    title: '人头完成比',
    width: 120,
    dataIndex: 'rt_count_percent',
    checked: true,
  },
  {
    title: '新会员目标数',
    width: 120,
    dataIndex: 'xhy_target_count',
    checked: true,
  },
  {
    title: '新会员成交数',
    width: 120,
    dataIndex: 'xhy_count',
    checked: true,
  },
  {
    title: '新会员成交比',
    width: 120,
    dataIndex: 'xhy_count_percent',
    checked: true,
  },
  {
    title: '转介绍到店数',
    width: 120,
    dataIndex: 'transfer_in_shop_count',
    checked: true,
  },
  {
    title: '转介绍成交数',
    width: 120,
    dataIndex: 'transfer_trade_count',
    checked: true,
  },
  {
    title: '转介绍成交额',
    width: 120,
    dataIndex: 'transfer_trade_amount',
    checked: true,
  },
  {
    title: '线上到店数',
    width: 120,
    dataIndex: 'online_shop_count',
    checked: true,
  },
  {
    title: '线上成交数',
    width: 120,
    dataIndex: 'online_trade_count',
    checked: true,
  },
  {
    title: '线上成交额',
    width: 120,
    dataIndex: 'online_trade_amount',
    checked: true,
  },
  {
    title: '老会员激活数',
    width: 120,
    dataIndex: 'old_customer_active_count',
    checked: true,
  },
  {
    title: '老会员激活成交额',
    width: 120,
    dataIndex: 'old_customer_active_trade_amount',
    checked: true,
  },
];
const newSlotList: any = [];
Object.assign(newSlotList, slotList);
// newSlotList.push({
//   type: 'custom',
//   // slotName: 'is_active',
//   field_true: '可用',
//   field_false: '作废',
// });

export default () => {
  return {
    searchConfig: search_config,
    searchConfigOptions: search_options,
    formModalConfig: edit_model_config,
    formModalConfigOptions: edit_model_config_options,
    updateFormModalConfig: update_model_config,
    updateFormModalConfigOptions: update_model_config_options,
    queryData: query_staff_operation_list,
    addData: null,
    updateData: null,
    removeData: null,
    recoverData: null,
    baseColumns: baseColumns,
    slotList: newSlotList,
    titleList: titleList,
    api_fields: api_fields,
    btn_list: btn_list,
    head_btn_list: head_btn_list,
    event_obj: event_obj,
    rowKey: '_index',
  };
};
